import { atom } from "recoil";
import { CustomerOrderType } from "../Domain";

export const customerChoice = atom<CustomerOrderType | undefined>({
	key: "customer-choice",
	default: undefined,
});
